import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { AppProviders } from './AppProviders';
import { MainLayout } from '@/components/layout/MainLayout';
// Dashboard is the entry page — eager import so it is part of the initial chunk (avoids LCP waterfall)
import { DashboardPage } from '@/features/dashboard/DashboardPage';

// Secondary routes — lazy-loaded after the app shell is already painted
const EventOverviewPage = lazy(() =>
  import('@/features/event-overview/EventOverviewPage').then((m) => ({ default: m.EventOverviewPage }))
);
const GuestDetailsPage = lazy(() =>
  import('@/features/guest-details/GuestDetailsPage').then((m) => ({ default: m.GuestDetailsPage }))
);
const UserAccessManagementPage = lazy(() =>
  import('@/features/user-access-management/UserAccessManagementPage').then((m) => ({
    default: m.UserAccessManagementPage,
  }))
);

function PageFallback() {
  return (
    <div className="flex h-64 items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-dds-blue" />
    </div>
  );
}

export function App() {
  return (
    <AppProviders>
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/event-overview/:eventCode" element={<EventOverviewPage />} />
            <Route path="/guest-details" element={<GuestDetailsPage />} />
            <Route path="/user-access-management" element={<UserAccessManagementPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </Suspense>
    </AppProviders>
  );
}
